import { useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const VALUES = [
  { word: 'Presence', desc: 'The quiet power of being fully here', bg: '#F5F0E8', color: '#1A4D38' },
  { word: 'Calm', desc: 'Stillness is not empty. It is full of answers', bg: '#E8EDE6', color: '#2D6B4A' },
  { word: 'Connection', desc: 'We heal in the presence of another', bg: '#EFE3D3', color: '#B85C38' },
  { word: 'Courage', desc: 'The gentle bravery of choosing yourself', bg: '#1A4D38', color: '#F5F0E8' },
];

const Values = () => {
  const root = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const items = gsap.utils.toArray('.value-item');
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.current,
          start: 'top top',
          end: `+=${VALUES.length * 100}%`,
          pin: true,
          scrub: 1.4,
        },
      });
      items.forEach((item, i) => {
        const word = item.querySelector('.value-word');
        const desc = item.querySelector('.value-desc');
        const pos = i * 3;
        tl.to(root.current, { backgroundColor: VALUES[i].bg, duration: 1.6, ease: 'none' }, pos);
        tl.fromTo(word, { opacity: 0, y: 80, letterSpacing: '0.05em' }, { opacity: 1, y: 0, letterSpacing: '0.12em', duration: 1.6, ease: 'power2.out' }, pos);
        tl.fromTo(desc, { opacity: 0, y: 30 }, { opacity: 0.75, y: 0, duration: 1.2, ease: 'power2.out' }, pos + 0.6);
        if (i < items.length - 1) {
          tl.to([word, desc], { opacity: 0, y: -60, duration: 1.2, ease: 'power2.in' }, pos + 2);
        }
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} data-testid="values-section" className="relative h-[100svh] overflow-hidden" style={{ backgroundColor: '#F5F0E8' }}>
      <p className="absolute top-16 md:top-24 left-6 md:left-16 text-[11px] uppercase tracking-[0.4em] text-[#2C2C2A]/40 z-10">What we live by</p>
      <div className="relative h-full">
        {VALUES.map((v, i) => (
          <div key={v.word} data-testid={`value-${v.word.toLowerCase()}`} className="value-item absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <h3 className="value-word font-serif-display font-light text-[11vw] sm:text-8xl lg:text-[9vw] leading-none uppercase max-w-full" style={{ color: v.color, opacity: 0 }}>
              {v.word}
            </h3>
            <p className="value-desc font-serif-display italic text-lg sm:text-2xl md:text-3xl mt-6 md:mt-12 max-w-[85%]" style={{ color: v.color, opacity: 0 }}>
              {v.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Values;
